var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 0.666626C4.3915 0.666626 0.666504 4.39163 0.666504 8.99996C0.666504 13.6083 4.3915 17.3333 8.99984 17.3333C13.6082 17.3333 17.3332 13.6083 17.3332 8.99996C17.3332 4.39163 13.6082 0.666626 8.99984 0.666626ZM13.1665 11.9916L11.9915 13.1666L8.99984 10.175L6.00817 13.1666L4.83317 11.9916L7.82484 8.99996L4.83317 6.00829L6.00817 4.83329L8.99984 7.82496L11.9915 4.83329L13.1665 6.00829L10.1748 8.99996L13.1665 11.9916Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconFilled);
export default __webpack_public_path__ + "static/media/close-icon-filled.44369c4c93c80d9e0a47389ac30839e1.svg";
export { ForwardRef as ReactComponent };